export const App_Labels = {
    PT: {
        0: "Aguarde, carregando...",
        1: "Seja bem-vindo(a) ao",
        2: "nosso sistema de avaliação",
        3: "Digite o código da avaliação para iniciar.",
        4: "Código da avaliação",
        5: "Iniciar",
        6: "Clique no botão abaixo para entrar com sua conta do ISE.",
        7: "ou",
        8: "Senha",     
        9: "Esqueci minha senha",
        10: "Entrar",
        11: "Informe o e-mail com o qual deseja iniciar o processo de recuperação de senha.",  
        12: "Informe seu e-mail",
        13: "Solicitar código",
        14: "Aviso",   
        15: "Para prosseguir é necessário informar os dados solicitados.",       
        16: "Fechar",
        17: "Foi enviado um código de recuperação de senha para o e-mail informado.",
        18: "Verifique em sua caixa postal para prosseguir com a redefinição de senha.",
        19: "Informe o código de recuperação para que o sistema envie uma nova senha.",
        20: "Informe seu código de recuperação",
        21: "Solicitar nova senha",     
        22: "Não foi possível concluir a ação. O código está expirado ou inválido. Por favor, repita o processo. Caso o problema persista, entre em contato com o suporte.",
        23: "Não foi possível concluir a ação. O código está expirado ou inválido. Por favor, repita o processo. Caso o problema persista, entre em contato com o suporte.",
        24: "Uma nova senha foi enviada para o e-mail informado",
        25: "utilize as novas credenciais para autenticação.",
        26: "utilize as novas credenciais para autenticação.",
        27: "Bem-vindo(a) ao ISE Survey! Resumo das avaliações de:",
        28: "Bem-vindo(a) ao ISE Survey!",  
        29: "Preparação",
        30: "Pronta/Em coleta",
        31: "Encerradas",
        32: "quantidade",
        33: "Pesquisar",
        34: "Identificador",
        35: "Código",
        36: "Descrição",      
        37: "Status",
        38: "Abertura",
        39: "Fechamento",
        40: "Em coleta",  
        41: "Você está alterando as preferências da sua conta",       
        42: "Primeiro nome",
        43: "Sobrenome",
        44: "de",
        45: "caracteres",   
        46: "Trocar senha",             
        47: "Atenção: a foto precisa estar na proporção quadrada e ser no formato PNG",               
        48: "Upload",
        49: "Salvar",
        50: "Você realmente deseja salvar essas alterações?",
        51: "Alguns elementos visuais do menu serão atualizados somente após sair e entrar novamente.",
        52: "Confirmar",              
        53: "Cancelar",     
        54: "Atenção",
        55: "Você está alterando as etiquetas relacionadas à sua conta",                   
        56: "Descrição da etiqueta",
        57: "Nova etiqueta",
        58: "Tem certeza de que deseja excluir este item?",            
        59: "Essa ação é irreversível e não será possível recuperar o item depois.",
        60: "É necessário preencher uma descrição e selecionar uma cor para a etiqueta.",
        61: "Sair",
        62: "Você realmente deseja confirmar a ação selecionada?",  
        63: "Avaliações",
        64: "Relatórios",
        65: "Modelos",
        66: "Pessoas",
        67: "Cadastros Gerais",       
        68: "Etiquetas",
        69: " Gerenciamento de avaliação",             
        70: "Avaliações prontas",
        71: "Avaliações encerradas",                    
        72: "Logos",
        73: "Estrutura de ensino",            
        74: "Redimensionador de Imagem",    
        75: "Relatório simples",              
        76: "Painel de Indicadores",
        77: "Exportação de planilha",      
        78: "Padrão",
        79: "Questões",
        80: "Listas",
        81: "Usuários",
        82: "Fotos de perfil",
        83: "Cadastros Gerais",
        84: "Designações", 
        85: "Setores",
        86: "Cargos",
        87: "Cores",
        88: "Slides",
        89: "Rodapés",
        90: "Etiquetas", 
        91: "Ocorreu um erro ao tentar fazer login com o método selecionado. Tente outro método. Caso o problema persista, entre em contato com o suporte técnico.",           
        92: "E-mail ou senha inválidos. Verifique os dados e tente novamente.",
        93: "Código inválido. Verifique os dados fornecidos.",
        94: "Informe sua senha.",
        95: "E-mail",
        96: "Entrar com a Microsoft",
        97: "Encerrado",
        98: "Coletado",
        99: "Pronto",
        100: "ISE Survey",
        101: "Utilize os controles do menu lateral para navegar entre as opções.",
        102: "Tem certeza de que deseja sair?",
        103: "As alterações não salvas serão perdidas.",
        104: "A descrição da cor é obrigatória.",
        105: "Para prosseguir com a criação é necessário selecionar uma cor.",
        106: "Registro salvo com sucesso!",
        107: "Oops",
        108: "Você realmente deseja salvar essa cor?",    
        109: "Tem certeza de que deseja excluir esta cor?",
        110: "Essa ação é irreversível e não será possível recuperar os dados depois.",
        111: "Informe a descrição da cor",                    
        112: "Descrição da cor (obrigatória)",
        113: "Visualização da seleção",
        114: "Excluir",
        115: "Editar",      
        116: "Visualização",
        117: "Criado",
        118: "Atualizado",
        119: "Gerenciamento de Cores",                                      
        120: "Novo",
        121: "A descrição do cargo é obrigatória.",
        122: "Você realmente deseja salvar esse cargo?", 
        123: "Tem certeza de que deseja excluir este cargo? Essa ação é irreversível e não será possível recuperá-lo depois.",
        124: "Informe a descrição do cargo",
        125: "Descrição do cargo (obrigatória)",
        126: "Usuários com acesso ao sistema",
        127: "Cargo",
        128: "Gerenciamento de cargos",       
        129: "A descrição do item é obrigatória.",
        130: "A descrição do item em português é obrigatória.",
        131: "A descrição do item em inglês é obrigatória.",
        132: "A descrição do item em espanhol é obrigatória.",
        133: "Você realmente deseja salvar essa designação?",
        134: "Tem certeza de que deseja excluir essa designação? Essa ação é irreversível e não será possível recuperá-la depois.",
        135: "Descrição da designação",
        136: "Descrição da Designação (obrigatória)",
        137: "Designação em português",
        138: "Descrição em português (obrigatória)",
        139: "Designação em inglês",
        140: "Descrição em inglês (obrigatória)",
        141: "Designação em espanhol",
        142: "Descrição em espanhol (obrigatória)",
        143: "Designação",
        144: "Gerenciamento de designações",
        145: "A descrição do arquivo é obrigatória.",
        146: "Para prosseguir com o upload é necessário selecionar uma imagem.",
        147: "Você realmente deseja salvar esse arquivo?",
        148: "Tem certeza de que deseja excluir este arquivo? Essa ação é irreversível e não será possível recuperá-lo depois.",
        149: "Informe a descrição da foto",
        150: "Descrição do arquivo (obrigatória)",
        151: "Atenção: A foto precisa estar na proporção retangular e em formato PNG.",
        152: "Preferencialmente 200 (pixels de largura) x 120 (pixels de altura).",
        153: "Remover",
        154: "Upload",
        155: "Gerenciamento de rodapés",
        156: "Gerenciamento de logos",
        157: "Não foi selecionado nenhum arquivo",
        158: "Dimensões acima do permitido",
        159: "Você realmente deseja prosseguir com a alteração?",
        160: "Arraste e solte seus logos aqui ou clique para selecionar",
        161: "Largura",
        162: "Altura",
        163: "Remover Itens",
        164: "Salvar ZIP",
        165: "Padronizador de Imagens",
        166: "Gerenciamento de fotos de usuário",
        167: "Página não encontrada. Por favor retorne à página de login ou escaneie novamente o QR Code da avaliação.",
        168: "Voltar",
        169: "É necessário ter pelo menos um item na lista.",    
        170: "É necessário incluir um texto em português para o item selecionado.",
        171: "É necessário incluir um texto em inglês para o item selecionado.",
        172: "É necessário incluir um texto em espanhol para o item selecionado.",
        173: "Não é um número decimal válido.",
        174: "Antes de salvar este item, salve a lista e depois volte para salvar o item.",
        175: "Descrição em português",
        176: "Descrição do item (obrigatória)",
        177: "Descrição em inglês",
        178: "Descrição em espanhol",
        179: "Peso",
        180: "Itens",
        181: "Novo item",   
        182: "É necessário incluir uma descrição para esta lista.",
        183: "É obrigatório selecionar pelo menos um idioma.",
        184: "Você realmente deseja salvar essa lista?",    
        185: "Operação não concluída.",
        186: "Há itens obrigatórios não preenchidos, em desencontro com as opções selecionadas.",
        187: "Verifique se há itens na lista e se os itens estão cadastrados corretamente.",
        188: "É necessário aguardar todas as operações anteriores antes de prosseguir com esta operação.",
        189: "Tem certeza de que deseja excluir essa lista? Essa ação é irreversível e não será possível recuperá-la depois.",
        190: "Informe a descrição da Lista",
        191: "Descrição da Lista (obrigatória)",
        192: "Salvar lista",         
        193: "Em Português",
        194: "Em Inglês",
        195: "Em Espanhol",
        196: "Possui peso",
        197: "Descrição da lista",
        198: "Gerenciamento de lista de perguntas e respostas",
        199: "Dica",       
        200: "Essa funcionalidade marcada habilita a descrição dos itens em português.",  
        201: "Essa funcionalidade marcada habilita a descrição dos itens em inglês.",
        202: "Essa funcionalidade marcada habilita a descrição dos itens em espanhol.",
        203: "Quando essa funcionalidade está ativada, um peso é atribuído a cada opção. Esses pesos são considerados em cálculos posteriores, à medida que os participantes selecionam os itens da lista.",
        204: "Português",       
        205: "Inglês",    
        206: "Espanhol",
        207: "Questão",
        208: "Selecione a questão",         
        209: "Idiomas",   
        210: "Prefixo",
        211: "Sem prefixo",
        212: "Obrigatório",
        213: "Negrito",
        214: "Você realmente deseja salvar esse padrão?",
        215: "Tem certeza de que deseja excluir esse padrão? Essa ação é irreversível e não será possível recuperá-lo depois.",
        216: "Informe a descrição do padrão",      
        217: "Descrição do padrão (obrigatória)",
        218: "O usuário já existe na lista",
        219: "Selecionar o usuário",
        220: "Não foi encontrada nenhuma ocorrência.",    
        221: "Usuário removido com sucesso!",        
        222: "Você está gerenciando",            
        223: "Adicionar usuário",                
        224: "Permissão",                    
        225: "Descrição do padrão",                      
        226: "Gerenciamento de lista de padrões",                      
        227: "Gerenciamento de padrão",
        228: "Gerenciamento dos usuários relacionados ao padrão",                    
        229: "Não encontrado",
        230: "A data de início não pode ser posterior à data de término",  
        231: "Ativo",  
        232: "Arquivado",
        233: "Selecione um status de busca",
        234: "Tipo de questão",       
        235: "Selecione o tipo de pergunta",           
        236: "Data inicial",
        237: "Data final",                   
        238: "Filtrar",          
        239: "Limpar filtros",              
        240: "Você realmente deseja salvar essa questão?",                 
        241: "Tem certeza de que deseja excluir essa questão? Essa ação é irreversível e não será possível recuperá-lo depois.",           
        242: "Informe a descrição da questão",                        
        243: "Informe a descrição da questão",
        244: "Selecione o tipo de questão",  
        245: "Tipos de questão",  
        246: "Selecione a lista para a resposta",  
        247: "Lista de resposta",      
        248: "Pergunta que será realizada no momento da resposta (obrigatória)",      
        249: "Descrição da questão",          
        250: "Gerenciamento de lista de perguntas",              
        251: "Gerenciamento de pergunta",                  
        252: "Gerenciamento dos usuários relacionados à questão",                      
        253: "Essa funcionalidade marcada habilita a visualização da pergunta em português.",                           
        254: "Essa funcionalidade marcada habilita a visualização da pergunta em inglês.",   
        255: "Essa funcionalidade marcada habilita a visualização da pergunta em espanhol.",      
        256: "A descrição do setor é obrigatória.",       
        257: "Para salvar esse setor selecione pelo menos um tipo de permissão.",              
        258: "Leitura",
        259: "Criar",                      
        260: "Deletar",
        261: "Lista de permissões do setor",                              
        262: "Você realmente deseja salvar esse setor?",                                  
        263: "Tem certeza de que deseja excluir este setor? Essa ação é irreversível e não será possível recuperá-lo depois.",                                       
        264: "Informe a descrição do setor",             
        265: "Informe a descrição do setor",                     
        266: "Selecione as permissões",                                                 
        267: "Lista de permissões",                                           
        268: "Setor",
        269: "Gerenciamento de setores",   
        270: "Arquivo selecionado com sucesso!",
        271: "Para criar um template (modelo) leia as instruções abaixo.",  
        272: "Você poderá redimensionar as imagens livremente, contudo, mantenha a mesma quantidade de imagens configuradas para uso no sistema.",
        273: "Restrito apenas ao redimensionamento e posicionamento.",  
        274: "A cor de fundo dos itens é alterada pelo sistema e seu preenchimento precisa estar configurado com um valor de cor hexadecimal.",      
        275: "Mantenha a cor sólida e no mesmo padrão. Todos os elementos da mesma cor serão substituídos pela cor selecionada, no momento de cadastramento da avaliação.",          
        276: "Informe a descrição do arquivo",              
        277: "Download do slide original",                 
        278: "Gerenciamento de slides",                      
        279: "A descrição da escola é obrigatória.",
        280: "Você realmente deseja salvar essa escola?",
        281: "Para excluir esta escola, primeiro remova os usuários associados e salve as alterações.",
        282: "Tem certeza de que deseja excluir esta escola? Essa ação é irreversível e não será possível recuperá-la depois.",
        283: "Informe a descrição da escola",
        284: "Descrição da escola (obrigatória)",
        285: "Você pode selecionar um usuário para ter acesso a esse registro",
        286: "Selecione um usuário",
        287: "Usuários com permissão a esse registro específico",
        288: "A descrição da área é obrigatória.",
        289: "É necessário selecionar uma escola para essa área.",    
        290: "Você realmente deseja salvar essa área?",     
        291: "Para excluir esta área, primeiro remova os usuários associados e salve as alterações.",         
        292: "Tem certeza de que deseja excluir esta área? Essa ação é irreversível e não será possível recuperá-la depois.",
        293: "Informe a descrição da área",
        294: "Descrição da área (obrigatória)",
        295: "Selecione a escola na qual essa área será criada", 
        296: "Selecione uma escola",     
        297: "A descrição do programa é obrigatória.",
        298: "É necessário selecionar uma área para esse programa.",
        299: "Você realmente deseja salvar esse programa?",    
        300: "Para excluir este programa, primeiro remova os usuários associados e salve as alterações.",
        301: "Tem certeza de que deseja excluir este programa? Essa ação é irreversível e não será possível recuperá-lo depois.",
        302: "Informe a descrição do programa",                 
        303: "Descrição do programa (obrigatória)",  
        304: "Selecione a área na qual esse programa será criado",                          
        305: "Selecione uma área",                   
        306: "A descrição do cliente é obrigatória.",
        307: "Você realmente deseja salvar esse cliente?",
        308: "Para excluir este cliente, primeiro remova os usuários associados e salve as alterações.",
        309: "Tem certeza de que deseja excluir este cliente? Essa ação é irreversível e não será possível recuperá-lo depois.",      
        310: "Informe a descrição da empresa",
        311: "Descrição do cliente (obrigatória)",
        312: "A descrição da área acadêmica é obrigatória.",  
        313: "Você realmente deseja salvar essa área acadêmica?",
        314: "Para excluir esta área acadêmica, primeiro remova os usuários associados e salve as alterações.",
        315: "Tem certeza de que deseja excluir esta área acadêmica? Essa ação é irreversível e não será possível recuperá-la depois.",  
        316: "Informe a descrição da área acadêmica",
        317: "Descrição desta área acadêmica (obrigatória)",
        318: "Escola",
        319: "Área",   
        320: "Hierarquia",       
        321: "Programa",          
        322: "Cliente",             
        323: "Área Acadêmica",                 
        324: "Estrutura de ensino",
        325: "Gerenciamento da estrutura de",
        326: "Escolas",
        327: "Áreas",
        328: "Programas",
        329: "Clientes",
        330: "Áreas Acadêmicas",             
        331: "Gerenciamento da escola",
        332: "Gerenciamento da área",
        333: "Gerenciamento do programa",
        334: "Gerenciamento do cliente",  
        335: "Gerenciamento da área acadêmica", 
        336: "Gerenciamento da estrutura de ensino",
        337: "Você realmente deseja alterar a senha?",
        338: "Após a confirmação, você será desconectado da sessão",
        339: "Verifique a senha, pois ela não obedece aos requisitos mínimos de segurança estabelecidos.",
        340: "A senha deve ter de 8 a 35 caracteres, conter letras minúsculas e maiúsculas, números e pelo menos um dos caracteres especiais !#@*.",
        341: "Nova senha",
        342: "Confirmar senha",
        343: "A senha e a confirmação de senha não são iguais.",
        344: "Há itens obrigatórios não preenchidos.",  
        345: "Verifique os itens de cadastro e tente novamente.",    
        346: "Primeiro nome (obrigatório)",            
        347: "Selecionar imagem do perfil",                
        348: "O endereço de e-mail fornecido",  
        349: "não é um endereço de e-mail válido, verifique os campos preenchidos e tente novamente.",
        350: "O nome de usuário é obrigatório.",
        351: "Selecione um setor para esse usuário.",
        352: "Selecione um cargo para esse usuário.",
        353: "Você realmente deseja salvar esse usuário?",
        354: "Tem certeza de que deseja excluir este usuário? Essa ação é irreversível e não será possível recuperá-lo depois.",
        355: "Endereço de e-mail completo",
        356: "E-mail (obrigatório)",
        357: "Primeiro nome",
        358: "Selecione o setor",  
        359: "Selecione o cargo",     
        360: "Restringir acesso",
        361: "Restringir dados",             
        362: "Selecione a foto de perfil",                 
        363: "Selecionar imagem",
        364: "Remover imagem",
        365: "Foto",  
        366: "Nome",
        367: "Gerenciamento de usuários", 
        368: "Essa funcionalidade ativada restringe o acesso às ordens do usuário no que ele estiver relacionado à escola, à área, ao programa ou a quaisquer subníveis da ordem de coleta; portanto, somente estarão disponíveis os dados que foram selecionados para ele. Por padrão, essa restrição está ativada, não permitindo o acesso a todos os relatórios da ordem de coleta.",
        369: "Essa funcionalidade ativada permite que o usuário visualize somente os dados de relatório do bloco no qual foi cadastrado; as demais informações não serão entregues a ele. Pode ser combinada para restringir os dados de acesso às ordens de coleta, exibindo apenas a informação à qual ele está vinculado e os dados da ordem que poderá visualizar.",    
        370: "Existem avaliações relacionadas a essa etiqueta. Deseja prosseguir com a solicitação de exclusão?",
        371: "Não há etiquetas criadas",  
        372: "Tem certeza de que deseja alterar o idioma?",
        373: "Existem padrões não associados ao idioma solicitado; ao confirmar a ação, os itens selecionados não serão identificados.",          
        374: "Descrição da avaliação",               
        375: "Descrição da avaliação (obrigatória)",
        376: "Observações",
        377: "Ao marcar este campo, você habilitará a coleta de um comentário por questão, seja uma reclamação, elogio ou sugestão.",
        378: "Essa funcionalidade é disponibilizada para toda pergunta, independentemente de seu tipo.",   
        379: "Selecione a escola",       
        380: "Selecione a área",
        381: "Selecione o programa",
        382: "Selecione o cliente",
        383: "Descrição da turma",      
        384: "Descrição da turma (obrigatória)",
        385: "Estilo do slide",
        386: "Rodapé do slide",
        387: "Cor principal do layout",
        388: "Início da coleta",
        389: "Final da coleta",
        390: "Adicionar usuário responsável",         
        391: "Lista de usuários responsáveis",
        392: "Nenhum usuário adicionado",
        393: " QR Codes da avaliação e do preview ",
        394: "Acesso do aluno",
        395: "Preview",
        396: "Adicionar um usuário ao relatório",
        397: "Lista de usuários com acesso específico ao relatório dessa avaliação",
        398: "Selecionar logo",
        399: "Linha de cabeçalho para português",
        400: "Descrição do cabeçalho",       
        401: "Linha de cabeçalho para inglês",   
        402: "Linha de cabeçalho para espanhol",
        403: "Adicionar logo",
        404: "Explicação",
        405: "Explicação em português",
        406: "Explicação em inglês",
        407: "Explicação em espanhol",
        408: "Legenda",  
        409: "Legenda em português",      
        410: "Legenda em inglês",  
        411: "Legenda em espanhol",
        412: "Selecione uma designação",
        413: "Usuário",
        414: "Rótulo",
        415: "Rótulo em português",
        416: "Rótulo em inglês",
        417: "Rótulo em espanhol",
        418: "Texto",
        419: "Texto em português",
        420: "Texto em inglês",
        421: "Texto em espanhol",
        422: "Idiomas",    
        423: "Prefixo (se desejável)",
        424: "Questões do padrão",
        425: "Não é possível remover esse item; é necessário ter pelo menos um item na lista. ",
        426: "Identificação do bloco",    
        427: "Descrição da sessão (obrigatória)",
        428: "Selecione a área acadêmica",
        429: "Adicionar linha de professor",
        430: "Rótulo e texto",
        431: "Selecione um padrão",
        432: "Adicionar questões",
        433: "Adicione mais uma questão",
        434: "Remover todas as questões",
        435: "Novo bloco",
        436: "A data de abertura é maior que a data de término.",
        437: "Não foi preenchida uma descrição para essa avaliação.",
        438: "Verifique a escola pois ela não foi selecionada.",
        439: "Verifique a área pois ela não foi selecionada.",
        440: "Verifique o programa pois ele não foi selecionado.",
        441: "Verifique o cliente pois ele não foi selecionado.",
        442: "A classe não foi preenchida corretamente.",
        443: "Não foi selecionado um tipo de template para o slide.",
        444: "Não foi selecionado um tipo de rodapé para o slide.",
        445: "Não foi selecionada uma cor para o slide e layout da avaliação.",
        446: "Inclua pelo menos uma explicação no idioma selecionado, uma vez que a opção foi habilitada.",
        447: "Inclua pelo menos uma legenda no idioma selecionado, uma vez que a opção foi habilitada.",
        448: "Inclua pelo menos uma sessão para prosseguir.",
        449: "Não foi preenchida uma descrição para a sessão na posição",
        450: "Não foi selecionada uma área acadêmica para a sessão na posição",
        451: "Não foi selecionado um usuário para a seção de Linha de Professor para a sessão na posição",
        452: "e na linha",
        453: "Não foi selecionada uma designação para a sessão de Linha de Professor para a sessão na posição",
        454: "Coloque pelo menos um Rótulo ou Texto para o idioma selecionado para a sessão na posição",
        455: "A pergunta",
        456: "do bloco",
        457: "e questão de posição",
        458: "não suporta Português.",
        459: "não suporta Inglês.",
        460: "não suporta Espanhol.",
        461: "Avaliação encerrada com sucesso!",
        462: "Você realmente deseja salvar essa avaliação?",
        463: "Há itens em conflito ou não preenchidos, verifique:",
        464: "Tem certeza de que deseja excluir essa avaliação? Essa ação é irreversível e não será possível recuperá-la depois.",
        465: "Você realmente deseja salvar e notificar os responsáveis desta avaliação?",
        466: "Você realmente deseja arquivar essa avaliação?",
        467: "Você realmente deseja voltar essa avaliação para o status em preparação?",
        468: "Operação realizada com sucesso!",
        469: "Você realmente deseja iniciar essa avaliação e a avançar para Pronta para Coleta?",
        470: "Você realmente deseja desarquivar essa ordem de coleta?",
        471: "Tem certeza de que deseja regerar os dados relacionados ao slide, QR Code e QR Code de prévia? Essa ação é irreversível e não será possível recuperá-los depois.",
        472: "Tem certeza de que deseja encerrar essa avaliação? Novos participantes não poderão enviar novas respostas.",
        473: "Você está gerenciando a avaliação: ",
        474: "De código: ",
        475: "Arquivar",
        476: "Desarquivar",
        477: "Regerar arquivos",
        478: "Pronta",
        479: "Encerrar",
        480: "Salvar e Notificar",
        481: "Download slide",
        482: "Enc. últimos 10d",
        483: "Selecione novamente as datas inicial e final para prosseguir com a pesquisa",
        484: "Simples",
        485: "Avançada",
        486: "Procurar pelo status",
        487: "Data inicial de pesquisa",
        488: "Data final de pesquisa",
        489: "Visualizar",
        490: "Copiar",
        491: "PDF",
        492: "Código da Avaliação",
        493: "Autor",
        494: "Gerenciamento geral de avaliações",
        495: "Gerenciamento da avaliação",
        496: "Geral",
        497: "Cabeçalho",
        498: "Questionário",   
        499: "Slide",
        500: "Código da Avaliação",
        501: "Copiar link",
        502: "Endereço copiado com sucesso!",
        503: "Fonte normal",
        504: "Fonte pequena",
        505: "Fonte grande",
        506: "Gostaria de comentar esta resposta com um elogio, sugestão ou reclamação?",
        507: "Resultados",
        508: "respostas coletadas",
        509: "Nome da questão",
        510: "Média",
        511: "D.P.",
        512: "Elogios, Sugestões, observações, ou reclamações realizadas por resposta:",
        513: "Itens escritos para",
        514: "Ocorrências",
        515: "Detratores",
        516: "Passivos",
        517: "Promotores",
        518: "As respostas em texto livre refletem fielmente o que os participantes digitaram",
        519: "Esta avaliação está fora do período de preenchimento",
        520: "Em caso de dúvida, entre em contato com a Coordenação do Programa",
        521: "Selecione pelo menos um status para realizar a busca",    
        522: "Selecione a Área Acadêmica",     
        523: "Data inicial (Fechamento)",
        524: "Data Final (Fechamento)",
        525: "Não foram selecionados dados para prosseguir com a consulta. Selecione um ou mais registros para continuar com a solicitação.",
        526: "Em coleta",
        527: "Relatório",
        528: "Qt.Respostas",
        529: "Consultar Agregado",   
        530: "Avaliações em coleta ou encerradas",
        531: "Ocorreu um erro. Caso o problema persista, entre em contato com o suporte.",
        532: "Filtrar por etiqueta",
        533: "Registro vinculado à",
        534: "com sucesso!",
        535: "Esse registro já estava vinculado à",
        536: "Por quesitos de performance, não é possível prosseguir com a solicitação",
        537: "Selecione um conjunto de até 10 avaliações para prosseguir com a solicitação.",
        538: "Solicitação efetuada com sucesso!",
        539: "Planilha",
        540: "Marcar",
        541: "Marcado como",
        542: "Educador",
        543: "Simples Agregado",    
        544: "Documento Agregado",
        545: "Registro já está vinculado à",
        546: "Remover itens da etiqueta",
        547: "Parâmetros",
        548: "Não há dados para mostrar",
        549: "Selecione pelo menos uma questão antes de realizar a busca",
        550: "Consultar",
        551: "Nova Consulta",
        552: "Arquivo gerado com sucesso!",
        553: "Arquivo gerado com sucesso!",
        554: "Consultar Dados",
        555: "Aderência abaixo de",
        556: "Abaixo de",
        557: "Aderência acima de",
        558: "Acima de",
        559: "Adesão à questão",
        560: "Download",
        561: "Cargos",
        562: "Tem certeza de que deseja prosseguir para outra funcionalidade?",
        563: "Bloco",
        564: "Turma",
        565: "Enviar",
        566: "Não respondido",
        567: "não foi respondida",
        568: "Há perguntas obrigatórias não respondidas. Por favor, verifique.",
        569: "Obrigado pela sua avaliação!",
        //570: "Cada comentário e sugestão é cuidadosamente analisado pela nossa equipe para que possamos continuar melhorando dia após dia.",
        570: "",
        571: "Ações",
        572: "Identificação",
        573: "Contexto",
        574: "Informações adicionais",
        575: "Etiquetas",
        576: "O link acessado é inválido",
        577: "Por favor, escaneie novamente o QR Code da avaliação ou clique no botão Voltar para inserir o código correto",
        578: "Preferências da conta",
        579: "Gerenciar etiquetas",
        580: "Por requisitos de performance, selecione um período inferior a 180 dias para prosseguir com a consulta.",
        581: "Relatórios do sistema anterior",
        582: "Esta página apresenta relatórios do sistema antigo. Ao abrir um relatório, você será redirecionado para esse sistema para download do documento, cuja geração de resultados é mais lenta.",
        583: "Solicitação realizada com sucesso. O sistema antigo está gerando o PDF, o que pode levar alguns minutos. Assim que o processo for finalizado, o download do arquivo será iniciado automaticamente.",
        584: "Avaliações prontas para coleta e em coleta - Painel de ações rápidas:",
        585: "Para acesso aos relatórios, clique no menu ou no botão acima.",
        586: "Aplicar",
        587: "Primeiro entre no Survey antigo e certifique-se que está autenticado na ferramenta e posteriormente clique no botão fechar X para prosseguir.",
        588: "Relatórios do período",
        589: "Para mudar o período clique na lupa, navegue entre as opções até aparecer as datas de fechamento e selecione o período de início e término.",
        590: "Planilha especifica",
        591: "Obter ajuda",
        592: "Bem vindo à ajuda do ISE Survey!",
        593: "Descreva sua solicitação e envie para nosso time para análise.",
        594: "Selecione a categoria",
        595: "Descreva a solicitação",
        596: "Sugestão",
        597: "Ajuda",
        598: "Obrigado por nos enviar sua solicitação!",
        599: "Sua mensagem é muito importante e nossa equipe de especialistas de suporte entrará em contato com você o mais breve possível.",
        600: "Nome da Avaliação",
        601: "Professor",
        602: "Número da Sessão",
        603: "Data de Resposta",
        604: "Resposta Dissertativa",
        605: "Texto da Resposta",
        606: "Valor da Resposta",
        607: "Tabela Dinâmica",
        608: "Selecionar tudo",        
        609: "Informações Acadêmicas",        
        610: "Contexto da questão",         
        611: "Contexto da resposta",                 
        612: "Nome público",    
        613: "Salvar Configuração",
        614: "Escolher outra configuração",
        615: "Publicado",   
        616: "Biblioteca de Templates",
        617: "Seus Modelos",
        618: "Pessoal",
        619: "Modelos públicos",
        620: "Público",
    },
    EN: {
        0: "Please wait, loading...",
        1: "Welcome to",
        2: "Our evaluation system",
        3: "Enter the evaluation code to begin.",
        4: "Enter evaluation code",
        5: "Start",
        6: "Click the button below to sign in with your ISE account.",
        7: "or",
        8: "Password",
        9: "Forgot my password",
        10: "Log in",
        11: "Enter the email you would like to start the password recovery process with.",
        12: "Enter your email",
        13: "Request Code",
        14: "Warning",
        15: "To proceed, you must provide the requested information.",
        16: "Close",
        17: "A password recovery code has been sent to the requested email,",
        18: "check your inbox to proceed with password reset.",
        19: "Enter the recovery code to have the Survey send a new password.",
        20: "Enter your recovery code",
        21: "Request new password",
        22: "The action could not be completed. The code is expired or invalid. Repeat the process. If the problem persists, please contact support.",
        23: "The action could not be completed. The code is expired or invalid. Repeat the process. If the problem persists, please contact support.",
        24: "A new password has been sent to your email",
        25: "use the new credentials for authentication.",
        26: "use the new credentials for authentication.",
        27: "Welcome to the ISE Survey! Summary of evaluations from:",
        28: "Welcome to the ISE Survey! Summary of evaluations from:",
        29: "Preparation",
        30: "Ready/In Collection",
        31: "Closed",
        32: "quantity",
        33: "Search",
        34: "Identifier",
        35: "Code",
        36: "Description",
        37: "Status",
        38: "Open",
        39: "Close",
        40: "In Collection",
        41: "You are changing the preferences of your account",
        42: "First Name",
        43: "Last Name",
        44: "from",
        45: "characters",
        46: "Change Password",
        47: "Note: The photo must be square and in PNG format",
        48: "Upload",
        49: "Save",
        50: "Are you sure you want to save these changes?",
        51: "Some visual menu identifications will only be updated after you log out and log back in.",
        52: "Confirm",
        53: "Cancel",
        54: "Attention",
        55: "You are changing the tags related to your account",
        56: "Tag Description",
        57: "New Tag",
        58: "Are you sure you want to delete this item?",
        59: "This action is irreversible and it will not be possible to recover it later.",
        60: "You must fill in a description and select a color for the tag.",
        61: "Log out",
        62: "Are you sure you want to confirm the selected action?",
        63: "Evaluations",
        64: "Reports",
        65: "Templates",
        66: "People",
        67: "General Registrations",
        68: "Tags",
        69: "Evaluation management",
        70: "Ready evaluations",
        71: "Closed evaluations",
        72: "Logos",
        73: "Education structure",
        74: "Image Resizer",
        75: "Simple report",
        76: "Indicator Dashboard",
        77: "Spreadsheet export",
        78: "Standard",
        79: "Questions",
        80: "Lists",
        81: "Users",
        82: "Profile photos",
        83: "General Registrations",
        84: "Designations",
        85: "Sectors",
        86: "Positions",
        87: "Colors",
        88: "Slides",
        89: "Footers",
        90: "Tags",
        91: "An error occurred while logging in using the selected method. Try with the other method. If the problem persists, please contact technical support.",
        92: "Check access data, invalid email or password.",
        93: "Check the data provided, invalid code.",
        94: "Enter your password.",
        95: "Email",
        96: "Log in with Microsoft",
        97: "Closed",
        98: "Collected",
        99: "Ready",
        100: "ISE Survey",
        101: "Use the side menu controls to navigate between options.",
        102: "Are you sure you want to log out?",
        103: "Unsaved changes will be lost.",
        104: "The color description is mandatory.",
        105: "To proceed with creation, you must select a color.",
        106: "Record saved successfully!",
        107: "Oops",
        108: "Are you sure you want to save this color?",
        109: "Are you sure you want to delete this color?",
        110: "This action is irreversible and it will not be possible to recover it later.",
        111: "Enter the color description",
        112: "Color Description (Mandatory)",
        113: "Selection view",
        114: "Delete",
        115: "Edit",
        116: "View",
        117: "Created",
        118: "Updated",
        119: "Color Management",
        120: "New",
        121: "The position description is mandatory.",
        122: "Are you sure you want to save this position?",
        123: "Are you sure you want to delete this position? This action is irreversible and it will not be possible to recover it later.",
        124: "Enter the Position description",
        125: "Position Description (Mandatory)",
        126: "Users with system access",
        127: "Position",
        128: "Position management",
        129: "The item description is mandatory.",
        130: "The item description in Portuguese is mandatory.",
        131: "The item description in English is mandatory.",
        132: "The item description in Spanish is mandatory.",
        133: "Are you sure you want to save this designation?",
        134: "Are you sure you want to delete this designation? This action is irreversible and it will not be possible to recover it later.",
        135: "Designation description",
        136: "Designation Description is (Mandatory)",
        137: "Designation in Portuguese",
        138: "Description in Portuguese is (Mandatory)",
        139: "Designation in English",
        140: "Description in English is (Mandatory)",
        141: "Designation in Spanish",
        142: "Description in Spanish is (Mandatory)",
        143: "Designation",
        144: "Designation Management",
        145: "The file description is mandatory.",
        146: "To proceed with the upload, you must select an image.",
        147: "Are you sure you want to save this file?",
        148: "Are you sure you want to delete this file? This action is irreversible and it will not be possible to recover it later.",
        149: "Enter the photo description",
        150: "File Description (Mandatory)",
        151: "Note: The photo must be rectangular and in PNG format.",
        152: "Preferably 200 (pixels wide) x 120 (pixels high).",
        153: "Remove",
        154: "Upload",
        155: "Footer Management",
        156: "Logo Management",
        157: "No file has been selected",
        158: "Dimensions above allowed",
        159: "Are you sure you want to proceed with the change?",
        160: "Drag and drop your logos here or click to select",
        161: "Width",
        162: "Height",
        163: "Remove Items",
        164: "Save Zip",
        165: "Image Standardizer",
        166: "User photo management",
        167: "Page not found, please return to the login page or scan the evaluation QR Code again",
        168: "Back",
        169: "You must have at least one item in the list.",
        170: "You must include a text in Portuguese for the selected item.",
        171: "You must include a text in English for the selected item.",
        172: "You must include a text in Spanish for the selected item.",
        173: "It is not a valid decimal number.",
        174: "Before proceeding and saving this item, proceed and save the list to subsequently save this item.",
        175: "Portuguese Description",
        176: "Item description (Mandatory)",
        177: "English Description",
        178: "Spanish Description",
        179: "Weight",
        180: "Items",
        181: "New Item",
        182: "You must include a description for this list.",
        183: "You must select at least one type of language.",
        184: "Are you sure you want to save this list?",
        185: "Operation not completed.",
        186: "There are mandatory items not filled out, which conflict with the selected options.",
        187: "Check if there are items in the list and if the items are correctly registered.",
        188: "You must wait for all previous operations before proceeding with this operation.",
        189: "Are you sure you want to delete this list? This action is irreversible and it will not be possible to recover it later.",
        190: "Enter the List description",
        191: "List Description (Mandatory)",
        192: "Save List",
        193: "In Portuguese",
        194: "In English",
        195: "In Spanish",
        196: "Has weight",
        197: "List Description",
        198: "Question and answer list management",
        199: "Hint",
        200: "This marked functionality enables the description of items in Portuguese.",
        201: "This marked functionality enables the description of items in English.",
        202: "This marked functionality enables the description of items in Spanish.",
        203: "This marked functionality activates the weight for each of the options, for later calculations using the items on the list as the options on this list are selected by the participants.",
        204: "Portuguese",
        205: "English",
        206: "Spanish",
        207: "Question",
        208: "Select the question",
        209: "Languages",
        210: "Prefix",
        211: "No prefix",
        212: "Mandatory",
        213: "Bold",
        214: "Are you sure you want to save this standard?",
        215: "Are you sure you want to delete this standard? This action is irreversible and it will not be possible to recover it later.",
        216: "Enter the Standard description",
        217: "Standard Description (Mandatory)",
        218: "The user already exists in the list",
        219: "Select the user",
        220: "No occurrence was found.",
        221: "User successfully removed!",
        222: "You are managing",
        223: "Add user",
        224: "Permission",
        225: "Standard Description",
        226: "Standard list management",
        227: "Standard management",
        228: "Management of users related to the standard",
        229: "Not found",
        230: "The start date cannot be later than the end date",
        231: "Active",
        232: "Archived",
        233: "Select a search status",
        234: "Question type",
        235: "Select the question type",
        236: "Start Date",
        237: "End Date",
        238: "Filter",
        239: "Clear Filters",
        240: "Are you sure you want to save this question?",
        241: "Are you sure you want to delete this question? This action is irreversible and it will not be possible to recover it later.",
        242: "Enter the Question description",
        243: "Enter the Question description",
        244: "Select the question type",
        245: "Question types",
        246: "Select the list for the answer",
        247: "Answer list",
        248: "Question to be asked at the time of the answer (Mandatory)",
        249: "Question Description",
        250: "Question list management",
        251: "Question management",
        252: "Management of users related to the question",
        253: "This marked functionality enables the display of the question in Portuguese.",
        254: "This marked functionality enables the display of the question in English.",
        255: "This marked functionality enables the display of the question in Spanish.",
        256: "The sector description is mandatory.",
        257: "To save this sector, select at least one type of permission.",
        258: "Read",
        259: "Create",
        260: "Delete",
        261: "Sector Permission List",
        262: "Are you sure you want to save this sector?",
        263: "Are you sure you want to delete this sector? This action is irreversible and it will not be possible to recover it later.",
        264: "Enter the sector description",
        265: "Enter the sector description",
        266: "Select the permissions",
        267: "Permission list",
        268: "Sector",
        269: "Sector management",
        270: "File selected successfully!",
        271: "To create a template, read the instructions below.",
        272: "You can resize the images freely, but keep the same number of images set, when used by the system.",
        273: "Restricted only to resizing and positioning them.",
        274: "The background color of the items is changed by the system and its filling must be configured with a hexadecimal color value",
        275: "Keep the color solid and in the same pattern, all elements of the same color will be replaced by the color selected at the time of registration of the evaluation.",
        276: "Enter the file description",
        277: "Download original Slide",
        278: "Slide Management",
        279: "The school description is mandatory.",
        280: "Are you sure you want to save this school?",
        281: "Before proceeding with this action to delete this school, first remove the users from the list and save the area to later carry out the deletion process.",
        282: "Are you sure you want to delete this school? This action is irreversible and it will not be possible to recover it later.",
        283: "Enter the school description",
        284: "School Description (Mandatory)",
        285: "You can select a user to have access to this record",
        286: "Select a user",
        287: "Users with permission for this specific record",
        288: "The area description is mandatory.",
        289: "You must select a school for this area.",
        290: "Are you sure you want to save this area?",
        291: "Before proceeding with this action to delete this area, first remove the users from the list and save the area to later carry out the deletion process.",
        292: "Are you sure you want to delete this area? This action is irreversible and it will not be possible to recover it later.",
        293: "Enter the area description",
        294: "Area Description is (Mandatory)",
        295: "Select the school in which this area will be created",
        296: "Select a school",
        297: "The program description is mandatory.",
        298: "You must select an area for this program.",
        299: "Are you sure you want to save this program?",
        300: "Before proceeding with this action to delete this program, first remove the users from the list and save the area to later carry out the deletion process.",
        301: "Are you sure you want to delete this program? This action is irreversible and it will not be possible to recover it later.",
        302: "Enter the program description",
        303: "Program Description is (Mandatory)",
        304: "Select the area in which this program will be created",
        305: "Select an area",
        306: "The client description is mandatory.",
        307: "Are you sure you want to save this client?",
        308: "Before proceeding with this action to delete this client, first remove the users from the list and save the area to later carry out the deletion process.",
        309: "Are you sure you want to delete this client? This action is irreversible and it will not be possible to recover it later.",
        310: "Enter the company description",
        311: "Client Description (Mandatory)",
        312: "The academic area description is mandatory.",
        313: "Are you sure you want to save this academic area?",
        314: "Before proceeding with this action to delete this academic area, first remove the users from the list and save the area to later carry out the deletion process.",
        315: "Are you sure you want to delete this academic area? This action is irreversible and it will not be possible to recover it later.",
        316: "Enter the academic area description",
        317: "Description of this Academic Area (Mandatory)",
        318: "School",
        319: "Area",
        320: "Hierarchy",
        321: "Program",
        322: "Client",
        323: "Academic Area",
        324: "Education structure",
        325: "Management of the structure of",
        326: "Schools",
        327: "Areas",
        328: "Programs",
        329: "Clients",
        330: "Academic Areas",
        331: "School management",
        332: "Area management",
        333: "Program management",
        334: "Client management",
        335: "Academic area management",
        336: "Education structure management",
        337: "Are you sure you want to change the password?",
        338: "After confirmation, you will be logged out of the session",
        339: "Check the password, as it does not meet the minimum security requirements established.",
        340: "The password must be between 8 and 35 characters, containing lowercase and uppercase letters, numbers and at least one of the special characters !#@*",
        341: "New password",
        342: "Confirm password",
        343: "The password and confirmation password are not the same.",
        344: "There are mandatory items not filled out.",
        345: "Check the registration items and try again.",
        346: "First name (Mandatory)",
        347: "Select profile image",
        348: "The email address provided",
        349: "is not a valid email address, check the filled fields and try again.",
        350: "The username is mandatory.",
        351: "Select a sector for this user.",
        352: "Select a position for this user.",
        353: "Are you sure you want to save this user?",
        354: "Are you sure you want to delete this user? This action is irreversible and it will not be possible to recover it later.",
        355: "Full email address",
        356: "Email (Mandatory)",
        357: "First name",
        358: "Select the sector",
        359: "Select the position",
        360: "Restrict access",
        361: "Restrict data",
        362: "Select profile photo",
        363: "Select Image",
        364: "Remove Image",
        365: "Photo",
        366: "Name",
        367: "User management",
        368: "This enabled functionality restricts access to the user's orders in what he is related to the school, area, program or any sub-levels of the collection order, therefore, only the data that has been selected for him will be available, by default this restriction is disabled allowing access to all reports of the collection order.",
        369: "This enabled functionality allows the user to view only the report data of the block in which he was registered, the other information will not be delivered to him, it can be combined to restrict access data to the collection orders, showing only the information he is linked to and the data in the order that he will be able to view.",
        370: "There are evaluations related to this tag, do you want to proceed with the deletion request?",
        371: "No tags created",
        372: "Are you sure you want to change the language?",
        373: "There are patterns not associated with the requested language, by confirming the action, the selected items will not be identified.",
        374: "Evaluation description",
        375: "Evaluation Description (Mandatory)",
        376: "Comments",
        377: "This marked functionality enables the possibility of collecting a comment, be it a complaint, compliment or suggestion.",
        378: "This functionality is available for every question regardless of its type.",
        379: "Select the school",
        380: "Select the Area",
        381: "Select the Program",
        382: "Select the Client",
        383: "Class description",
        384: "Class description (Mandatory)",
        385: "Slide Style",
        386: "Slide Footer",
        387: "Main layout color",
        388: "Start of Collection",
        389: "End of Collection",
        390: "Add responsible user",
        391: "List of responsible users",
        392: "No user added",
        393: "Evaluation and preview QRCodes",
        394: "Student access",
        395: "Preview",
        396: "Add report user",
        397: "List of users with specific access to the report of this evaluation",
        398: "Select Logo",
        399: "Header line for Portuguese",
        400: "Header description",
        401: "Header line for English",
        402: "Header line for Spanish",
        403: "Add logo",
        404: "Explanation",
        405: "Explanation for Portuguese",
        406: "Explanation for English",
        407: "Explanation for Spanish",
        408: "Caption",
        409: "Caption for Portuguese",
        410: "Caption for English",
        411: "Caption for Spanish",
        412: "Select a designation",
        413: "User",
        414: "Label",
        415: "Label in Portuguese",
        416: "Label in English",
        417: "Label in Spanish",
        418: "Text",
        419: "Text in Portuguese",
        420: "Text in English",
        421: "Text in Spanish",
        422: "Languages",
        423: "Prefix (Desirable)",
        424: "Standard questions",
        425: "It is not possible to remove this item, you must have at least one item in the list",
        426: "Session header",
        427: "Session description (Mandatory)",
        428: "Select the academic area",
        429: "Add professor line",
        430: "Label and text",
        431: "Select a standard",
        432: "Add Questions",
        433: "Add another question",
        434: "Remove all questions",
        435: "New Block",
        436: "The start date is after the end date.",
        437: "A description was not filled out for this evaluation.",
        438: "Check the school as it was not selected.",
        439: "Check the area as it was not selected.",
        440: "Check the program as it was not selected.",
        441: "Check the client as it was not selected.",
        442: "The class was not filled in correctly.",
        443: "A template type was not selected for the slide.",
        444: "A footer type was not selected for the slide.",
        445: "A color was not selected for the slide and evaluation layout.",
        446: "Place at least one explanation for the selected language once it has been enabled to place an explanation.",
        447: "Place at least one caption for the selected language once it has been enabled to place an explanation.",
        448: "Include at least one session to proceed.",
        449: "A description for the session was not filled out in position",
        450: "An academic area was not selected for the session in position",
        451: "A User was not selected for the Professor Line session for the session in position",
        452: "and on the line",
        453: "A Designation was not selected for the Professor Line session for the session in position",
        454: "Place at least one Label or Text for the selected language for the session in position",
        455: "The question",
        456: "of the block",
        457: "and question of position",
        458: "does not support Portuguese.",
        459: "does not support English.",
        460: "does not support Spanish.",
        461: "Evaluation successfully closed!",
        462: "Are you sure you want to save this evaluation?",
        463: "There are conflicting or unfilled items, check:",
        464: "Are you sure you want to delete this evaluation? This action is irreversible and it will not be possible to recover it later.",
        465: "Are you sure you want to save and notify those responsible for the changes to this evaluation?",
        466: "Are you sure you want to archive this evaluation?",
        467: "Are you sure you want to put this evaluation back in preparation?",
        468: "Operation performed successfully!",
        469: "Are you sure you want to start this evaluation and make it ready for collection?",
        470: "Are you sure you want to unarchive this collection order?",
        471: "Are you sure you want to re-generate the data related to the slide, qrcode and qrcode preview? This action is irreversible and it will not be possible to recover it later.",
        472: "Are you sure you want to close this evaluation? New participants will not be able to submit new answers.",
        473: "You are managing the evaluation:",
        474: "With code:",
        475: "Archive",
        476: "Unarchive",
        477: "Re-generate files",
        478: "Ready",
        479: "Close",
        480: "Save and Notify",
        481: "Download Slide",
        482: "Closed last 10d",
        483: "Select the start and end dates again to proceed with the search",
        484: "Simple",
        485: "Advanced",
        486: "Search by status",
        487: "Start search date",
        488: "End search date",
        489: "View",
        490: "Copy",
        491: "PDF",
        492: "Evaluation Code",
        493: "Author",
        494: "General evaluation management",
        495: "Evaluation management",
        496: "General",
        497: "Header",
        498: "Questionnaire",
        499: "Slide",
        500: "Order Code",
        501: "Copy link",
        502: "Address copied successfully!",
        503: "Normal Font",
        504: "Small Font",
        505: "Large Font",
        506: "Would you like to comment on this answer, make a compliment, suggestion or complaint about it?",
        507: "Results",
        508: "responses collected",
        509: "Question Name",
        510: "Average",
        511: "S.D.",
        512: "Compliments, Suggestions, comments, or complaints made per response:",
        513: "Items written for",
        514: "Occurrences",
        515: "Detractors",
        516: "Passives",
        517: "Promoters",
        518: "Free text responses faithfully reflect what participants typed",
        519: "This evaluation is outside the completion period",
        520: "In case of doubt, contact the Program coordination",
        521: "Select at least one status to perform the search",
        522: "Select the Academic Area",
        523: "Start date (Closing)",
        524: "End Date (Closing)",
        525: "No data was selected to proceed with the query, select one or more records to proceed with the request",
        526: "In collection",
        527: "Report",
        528: "Qty.Responses",
        529: "Consult Aggregate",
        530: "Evaluations in collection or closed",
        531: "An error occurred, if the problem persists, please contact support.",
        532: "Filter by tag",
        533: "Record linked to",
        534: "successfully!",
        535: "This record was already linked to",
        536: "For performance reasons, it is not possible to proceed with the request",
        537: "Select a set of up to 10 evaluations to proceed with the request.",
        538: "Request successfully completed!",
        539: "Spreadsheet",
        540: "Mark",
        541: "Marked as",
        542: "Educator",
        543: "Simple Aggregate",
        544: "Aggregate Document",
        545: "Record is already linked to",
        546: "Remove items from tag",
        547: "Parameters",
        548: "No data to show",
        549: "Select at least one question before performing the search",
        550: "Consult",
        551: "New Query",
        552: "File generated successfully!",
        553: "File generated successfully!",
        554: "Consult Data",
        555: "Adherence below",
        556: "Below",
        557: "Adherence above",
        558: "Above",
        559: "Adherence to the question",
        560: "Download",
        561: "Positions",
        562: "Are you sure you want to proceed to another functionality?",
        563: "Block",
        564: "Class",
        565: "Send",  
        566: "Not Answered",
        567: "was not answered",  
        568: "There are mandatory questions not answered, please check",
        569: "Thank you for your feedback!",
        //570: "Every comment and suggestion is carefully analyzed by our team so that we can continue to improve day after day.",
        570: "",        
        571: "Actions",
        572: "Identification",
        573: "Context",
        574: "Additional data",
        575: "Tags",
        576: "The link you accessed is invalid",
        577: "Please scan the evaluation QR Code again or click the Back button to enter the correct code",
        578: "Account preference",
        579: "Manage tags",
        580: "For performance requirements, please select a period of less than 180 days to proceed with the query.",        
        581: "Old Reports",  
        582: "This page displays reports from the legacy system. When you open a report, you'll be redirected to this system to download the document, which generates results more slowly.",
        583: "Request completed successfully. The old system is generating the PDF, which may take a few minutes. Once the process is complete, the file will automatically start downloading.",    
        584: "Assessments ready for collection and in collection - Quick Actions Dashboard:",
        585: "To access the reports, click on the menu or the button above.",        
        586: "Apply",
        587: "First, log into the old Survey and make sure you are authenticated in the tool and then click the close X button to continue.",
        588: "Reports period",
        589: "To change the period, click on the magnifying glass, navigate through the options until the closing dates appear, and select the start and end dates.",
        590: "Specific spreadsheet",        
        591: "Get help",
        592: "Welcome to ISE Survey help!",
        593: "Describe your request and send it to us for review.",
        594: "Category selection",
        595: "Describe the request",
        596: "Suggestion",
        597: "Help",   
        598: "Thank you for sending us your request!",
        599: "Your message is very important and our team of support experts will contact you as soon as possible.",
        600: "Assessment Name",
        601: "Professor",
        602: "Session Number",
        603: "Response Date",
        604: "Essay Response",
        605: "Response Text",
        606: "Response Value",
        607: "Pivot Table",
        608: "Select All",
        609: "Academic Information",
        610: "Question Context",
        611: "Response Context",   
        612: "Public Name",
        613: "Save Configuration",
        614: "Choose another configuration",
        615: "Published",
        616: "Template Library",
        617: "Your Templates",
        618: "Personal",
        619: "Public Templates",
        620: "Public",
    },
    ES: {
        0: "Espere, cargando...",
        1: "Bienvenido a",
        2: "Nuestro sistema de evaluación",
        3: "Ingrese el código de evaluación para comenzar.",
        4: "Ingrese el código de evaluación",
        5: "Iniciar",
        6: "Haga clic en el botón de abajo para iniciar sesión con su cuenta de ISE.",
        7: "o",
        8: "Contraseña",
        9: "Olvidé mi contraseña",
        10: "Iniciar sesión",
        11: "Ingrese el correo electrónico para iniciar el proceso de recuperación de contraseña.",
        12: "Ingrese su correo electrónico",
        13: "Solicitar Código",
        14: "Advertencia",
        15: "Para continuar, debe proporcionar los datos solicitados.",
        16: "Cerrar",
        17: "Se ha enviado un código de recuperación de contraseña al correo electrónico solicitado,",
        18: "verifique su bandeja de entrada para continuar con el restablecimiento de la contraseña.",
        19: "Ingrese el código de recuperación para que el Sistema de Encuestas envíe una nueva contraseña.",
        20: "Ingrese su código de recuperación",
        21: "Solicitar nueva contraseña",
        22: "No se pudo completar la acción. El código ha expirado o es inválido. Repita el proceso. Si el problema persiste, contacte a soporte.",
        23: "No se pudo completar la acción. El código ha expirado o es inválido. Repita el proceso. Si el problema persiste, contacte a soporte.",
        24: "Se ha enviado una nueva contraseña al correo electrónico",
        25: "utilice las nuevas credenciales para la autenticación.",
        26: "utilice las nuevas credenciales para la autenticación.",
        27: "¡Bienvenido/a a ISE Survey! Resumen de las evaluaciones de:",
        28: "¡Bienvenido/a a ISE Survey! Resumen de las evaluaciones de:",
        29: "Preparación",
        30: "Listo/En Recopilación",
        31: "Cerrado",
        32: "cantidad",
        33: "Buscar",
        34: "Identificador",
        35: "Código",
        36: "Descripción",
        37: "Estado",
        38: "Apertura",
        39: "Cierre",
        40: "En Recopilación",
        41: "Está cambiando sus preferencias de cuenta",
        42: "Primer Nombre",
        43: "Apellido",
        44: "de",
        45: "caracteres",
        46: "Cambiar Contraseña",
        47: "Atención: La foto debe ser cuadrada y estar en formato PNG",
        48: "Cargar",
        49: "Guardar",
        50: "¿Está seguro de que desea guardar estos cambios?",
        51: "Algunas identificaciones visuales del menú solo se actualizarán después de cerrar y volver a iniciar sesión.",
        52: "Confirmar",
        53: "Cancelar",
        54: "Atención",
        55: "Está cambiando las etiquetas relacionadas con su cuenta",
        56: "Descripción de la Etiqueta",
        57: "Nueva Etiqueta",
        58: "¿Está seguro de que desea eliminar este elemento?",
        59: "Esta acción es irreversible y no podrá recuperarlo después.",
        60: "Es obligatorio completar una descripción y seleccionar un color para la etiqueta.",
        61: "Salir",
        62: "¿Está seguro de que desea confirmar la acción seleccionada?",
        63: "Evaluaciones",
        64: "Informes",
        65: "Modelos",
        66: "Personas",
        67: "Registros Generales",
        68: "Etiquetas",
        69: "Gestión de evaluación",
        70: "Evaluaciones listas",
        71: "Evaluaciones cerradas",
        72: "Logos",
        73: "Estructura de enseñanza",
        74: "Redimensionador de Imagen",
        75: "Informe simple",
        76: "Panel de Indicadores",
        77: "Exportación de hoja de cálculo",
        78: "Estándar",
        79: "Preguntas",
        80: "Listas",
        81: "Usuarios",
        82: "Fotos de perfil",
        83: "Registros Generales",
        84: "Designaciones",
        85: "Sectores",
        86: "Cargos",
        87: "Colores",
        88: "Diapositivas",
        89: "Pies de página",
        90: "Etiquetas",
        91: "Ocurrió un error al iniciar sesión con el método seleccionado. Intente con el otro método. Si el problema persiste, contacte a soporte técnico.",
        92: "Verifique los datos de acceso, correo electrónico o contraseña inválidos.",
        93: "Verifique los datos proporcionados, código inválido.",
        94: "Ingrese su contraseña.",
        95: "Correo electrónico",
        96: "Iniciar sesión con Microsoft",
        97: "Cerrado",
        98: "Recopilado",
        99: "Listo",
        100: "ISE Survey",
        101: "Use los controles del menú lateral para navegar entre las opciones.",
        102: "¿Está seguro de que desea salir?",
        103: "Se perderán los cambios no guardados.",
        104: "La descripción del color es obligatoria.",
        105: "Para continuar con la creación, es necesario seleccionar un color.",
        106: "¡Registro guardado con éxito!",
        107: "Oops",
        108: "¿Está seguro de que desea guardar este color?",
        109: "¿Está seguro de que desea eliminar este color?",
        110: "Esta acción es irreversible y no podrá recuperarlo después.",
        111: "Ingrese la descripción del color",
        112: "Descripción del Color (Obligatorio)",
        113: "Vista previa de la selección",
        114: "Eliminar",
        115: "Editar",
        116: "Vista previa",
        117: "Creado",
        118: "Actualizado",
        119: "Gestión de Colores",
        120: "Nuevo",
        121: "La descripción del cargo es obligatoria.",
        122: "¿Está seguro de que desea guardar este cargo?",
        123: "¿Está seguro de que desea eliminar este cargo? Esta acción es irreversible y no podrá recuperarlo después.",
        124: "Ingrese la descripción del Cargo",
        125: "Descripción del Cargo (Obligatorio)",
        126: "Usuarios con acceso al sistema",
        127: "Cargo",
        128: "Gestión de cargos",
        129: "La descripción del elemento es obligatoria.",
        130: "La descripción del elemento en portugués es obligatoria.",
        131: "La descripción del elemento en inglés es obligatoria.",
        132: "La descripción del elemento en español es obligatoria.",
        133: "¿Está seguro de que desea guardar esta designación?",
        134: "¿Está seguro de que desea eliminar esta designación? Esta acción es irreversible y no podrá recuperarlo después.",
        135: "Descripción de la designación",
        136: "La Descripción de la Designación es (Obligatoria)",
        137: "Designación en portugués",
        138: "La Descripción en portugués es (Obligatoria)",
        139: "Designación en inglés",
        140: "La Descripción en inglés es (Obligatoria)",
        141: "Designación en español",
        142: "La Descripción en español es (Obligatoria)",
        143: "Designación",
        144: "Gestión de Designaciones",
        145: "La descripción del archivo es obligatoria.",
        146: "Para continuar con la carga, es necesario seleccionar una imagen.",
        147: "¿Está seguro de que desea guardar este archivo?",
        148: "¿Está seguro de que desea eliminar este archivo? Esta acción es irreversible y no podrá recuperarlo después.",
        149: "Ingrese la descripción de la foto",
        150: "Descripción del Archivo (Obligatorio)",
        151: "Atención: La foto debe tener una proporción rectangular y ser en formato PNG.",
        152: "Preferiblemente 200 (píxeles de ancho) x 120 (píxeles de alto).",
        153: "Eliminar",
        154: "Cargar",
        155: "Gestión de Pies de página",
        156: "Gestión de Logos",
        157: "No se ha seleccionado ningún archivo",
        158: "Dimensiones superiores a las permitidas",
        159: "¿Está seguro de que desea continuar con el cambio?",
        160: "Arrastre y suelte sus logos aquí o haga clic para seleccionarlos",
        161: "Ancho",
        162: "Alto",
        163: "Eliminar Elementos",
        164: "Guardar Zip",
        165: "Estandarizador de Imágenes",
        166: "Gestión de fotos de usuario",
        167: "Página no encontrada, por favor regrese a la página de inicio de sesión o escanee nuevamente el QR Code de la evaluación",
        168: "Volver",
        169: "Es necesario tener al menos un elemento en la lista.",
        170: "Es necesario incluir un texto en portugués para el elemento seleccionado.",
        171: "Es necesario incluir un texto en inglés para el elemento seleccionado.",
        172: "Es necesario incluir un texto en español para el elemento seleccionado.",
        173: "No es un número decimal válido.",
        174: "Antes de continuar y guardar este elemento, guarde la lista para poder guardar este elemento posteriormente.",
        175: "Descripción Portugués",
        176: "Descripción del elemento (Obligatorio)",
        177: "Descripción Inglés",
        178: "Descripción Español",
        179: "Peso",
        180: "Elementos",
        181: "Nuevo Elemento",
        182: "Es necesario incluir una descripción para esta lista.",
        183: "Es obligatorio seleccionar al menos un tipo de idioma.",
        184: "¿Está seguro de que desea guardar esta lista?",
        185: "Operación no completada.",
        186: "Hay elementos obligatorios no completados que entran en conflicto con las opciones seleccionadas.",
        187: "Verifique si hay elementos en la lista y si los elementos están registrados correctamente.",
        188: "Es necesario esperar todas las operaciones anteriores antes de continuar con esta operación.",
        189: "¿Está seguro de que desea eliminar esta lista? Esta acción es irreversible y no podrá recuperarla después.",
        190: "Ingrese la descripción de la Lista",
        191: "Descripción de la Lista (Obligatorio)",
        192: "Guardar Lista",
        193: "En Portugués",
        194: "En Inglés",
        195: "En Español",
        196: "Tiene peso",
        197: "Descripción de la Lista",
        198: "Gestión de lista de preguntas y respuestas",
        199: "Consejo",
        200: "Esta funcionalidad marcada habilita la descripción de los elementos en portugués.",
        201: "Esta funcionalidad marcada habilita la descripción de los elementos en inglés.",
        202: "Esta funcionalidad marcada habilita la descripción de los elementos en español.",
        203: "Esta funcionalidad marcada activa el peso para cada una de las opciones, para cálculos posteriores utilizando los elementos de la lista conforme a las opciones que los participantes seleccionan.",
        204: "Portugués",
        205: "Inglés",
        206: "Español",
        207: "Pregunta",
        208: "Seleccione la pregunta",
        209: "Idiomas",
        210: "Prefijo",
        211: "Sin prefijo",
        212: "Obligatorio",
        213: "Negrita",
        214: "¿Está seguro de que desea guardar este estándar?",
        215: "¿Está seguro de que desea eliminar este estándar? Esta acción es irreversible y no podrá recuperarlo después.",
        216: "Ingrese la descripción del Estándar",
        217: "Descripción del Estándar (Obligatorio)",
        218: "El usuario ya existe en la lista",
        219: "Seleccionar el usuario",
        220: "No se encontró ninguna ocurrencia.",
        221: "¡Usuario eliminado con éxito!",
        222: "Está gestionando",
        223: "Añadir usuario",
        224: "Permiso",
        225: "Descripción del Estándar",
        226: "Gestión de lista de estándares",
        227: "Gestión de estándar",
        228: "Gestión de los usuarios relacionados con el estándar",
        229: "No encontrado",
        230: "La fecha de inicio no puede ser posterior a la fecha de finalización",
        231: "Activo",
        232: "Archivado",
        233: "Seleccione un estado de búsqueda",
        234: "Tipo de pregunta",
        235: "Seleccione el tipo de pregunta",
        236: "Fecha inicial",
        237: "Fecha final",
        238: "Filtrar",
        239: "Limpiar Filtros",
        240: "¿Está seguro de que desea guardar esta pregunta?",
        241: "¿Está seguro de que desea eliminar esta pregunta? Esta acción es irreversible y no podrá recuperarla después.",
        242: "Ingrese la descripción de la Pregunta",
        243: "Ingrese la descripción de la Pregunta",
        244: "Seleccione el tipo de pregunta",
        245: "Tipos de pregunta",
        246: "Seleccione la lista para la respuesta",
        247: "Lista de respuesta",
        248: "Pregunta que se realizará en el momento de la respuesta (Obligatorio)",
        249: "Descripción de la Pregunta",
        250: "Gestión de lista de preguntas",
        251: "Gestión de pregunta",
        252: "Gestión de los usuarios relacionados con la pregunta",
        253: "Esta funcionalidad marcada habilita la visualización de la pregunta en portugués.",
        254: "Esta funcionalidad marcada habilita la visualización de la pregunta en inglés.",
        255: "Esta funcionalidad marcada habilita la visualización de la pregunta en español.",
        256: "La descripción del sector es obligatoria.",
        257: "Para guardar este sector, seleccione al menos un tipo de permiso.",
        258: "Leer",
        259: "Crear",
        260: "Eliminar",
        261: "Lista de Permisos del sector",
        262: "¿Está seguro de que desea guardar este sector?",
        263: "¿Está seguro de que desea eliminar este sector? Esta acción es irreversible y no podrá recuperarlo después.",
        264: "Ingrese la descripción del sector",
        265: "Ingrese la descripción del sector",
        266: "Seleccione los permisos",
        267: "Lista de permisos",
        268: "Sector",
        269: "Gestión de sectores",
        270: "¡Archivo seleccionado con éxito!",
        271: "Para crear un modelo de plantilla, lea las instrucciones a continuación.",
        272: "Podrá redimensionar las imágenes libremente, sin embargo, mantenga la misma cantidad de imágenes configuradas al ser utilizadas por el sistema.",
        273: "Restringido solo al redimensionamiento y posicionamiento de las mismas.",
        274: "El color de fondo de los elementos es alterado por el sistema y su relleno debe estar configurado con un valor de color hexadecimal",
        275: "Mantenga el color sólido y en el mismo patrón, todos los elementos del mismo color serán sustituidos por el color seleccionado al momento de registrar la evaluación.",
        276: "Ingrese la descripción del archivo",
        277: "Descargar Diapositiva original",
        278: "Gestión de Diapositivas",
        279: "La descripción de la escuela es obligatoria.",
        280: "¿Está seguro de que desea guardar esta escuela?",
        281: "Antes de continuar con esta acción para eliminar esta escuela, primero elimine los usuarios de la lista y guarde el área para posteriormente realizar el proceso de eliminación.",
        282: "¿Está seguro de que desea eliminar esta escuela? Esta acción es irreversible y no podrá recuperarla después.",
        283: "Ingrese la descripción de la escuela",
        284: "Descripción de la Escuela (Obligatorio)",
        285: "Puede seleccionar un usuario para que tenga acceso a este registro",
        286: "Seleccione un usuario",
        287: "Usuarios con permiso a este registro específico",
        288: "La descripción del área es obligatoria.",
        289: "Es necesario seleccionar una escuela para esta área.",
        290: "¿Está seguro de que desea guardar esta área?",
        291: "Antes de continuar con esta acción para eliminar esta área, primero elimine los usuarios de la lista y guarde el área para posteriormente realizar el proceso de eliminación.",
        292: "¿Está seguro de que desea eliminar esta área? Esta acción es irreversible y no podrá recuperarla después.",
        293: "Ingrese la descripción del área",
        294: "Descripción del Área es (Obligatorio)",
        295: "Seleccione la escuela en la que se creará esta área",
        296: "Seleccione una escuela",
        297: "La descripción del programa es obligatoria.",
        298: "Es necesario seleccionar un área para este programa.",
        299: "¿Está seguro de que desea guardar este programa?",
        300: "Antes de continuar con esta acción para eliminar este programa, primero elimine los usuarios de la lista y guarde el área para posteriormente realizar el proceso de eliminación.",
        301: "¿Está seguro de que desea eliminar este programa? Esta acción es irreversible y no podrá recuperarlo después.",
        302: "Ingrese la descripción del programa",
        303: "Descripción del Programa es (Obligatorio)",
        304: "Seleccione el área en la que se creará este programa",
        305: "Seleccione un área",
        306: "La descripción del cliente es obligatoria.",
        307: "¿Está seguro de que desea guardar este cliente?",
        308: "Antes de continuar con esta acción para eliminar este cliente, primero elimine los usuarios de la lista y guarde el área para posteriormente realizar el proceso de eliminación.",
        309: "¿Está seguro de que desea eliminar este cliente? Esta acción es irreversible y no podrá recuperarlo después.",
        310: "Ingrese la descripción de la empresa",
        311: "Descripción del Cliente (Obligatorio)",
        312: "La descripción del área académica es obligatoria.",
        313: "¿Está seguro de que desea guardar esta área académica?",
        314: "Antes de continuar con esta acción para eliminar esta área académica, primero elimine los usuarios de la lista y guarde el área para posteriormente realizar el proceso de eliminación.",
        315: "¿Está seguro de que desea eliminar esta área académica? Esta acción es irreversible y no podrá recuperarla después.",
        316: "Ingrese la descripción del área académica",
        317: "Descripción de esta Área Académica (Obligatorio)",
        318: "Escuela",
        319: "Área",
        320: "Jerarquía",
        321: "Programa",
        322: "Cliente",
        323: "Área Académica",
        324: "Estructura de enseñanza",
        325: "Gestión de la estructura de",
        326: "Escuelas",
        327: "Áreas",
        328: "Programas",
        329: "Clientes",
        330: "Áreas Académicas",
        331: "Gestión de la escuela",
        332: "Gestión del área",
        333: "Gestión del programa",
        334: "Gestión del cliente",
        335: "Gestión del área académica",
        336: "Gestión de la estructura de enseñanza",
        337: "¿Está seguro de que desea cambiar la contraseña?",
        338: "Después de la confirmación, se cerrará la sesión",
        339: "Verifique la contraseña, ya que no cumple con los requisitos mínimos de seguridad establecidos.",
        340: "La contraseña debe tener de 8 a 35 caracteres, contener letras minúsculas y mayúsculas, números y al menos uno de los caracteres especiales !#@*",
        341: "Nueva contraseña",
        342: "Confirmar contraseña",
        343: "La contraseña y la confirmación de la contraseña no coinciden.",
        344: "Hay elementos obligatorios no completados.",
        345: "Verifique los elementos de registro e intente de nuevo.",
        346: "Primer nombre (Obligatorio)",
        347: "Seleccionar Imagen de perfil",
        348: "La dirección de correo electrónico proporcionada",
        349: "no es una dirección de correo electrónico válida, verifique los campos completados e intente de nuevo.",
        350: "El nombre de usuario es obligatorio.",
        351: "Seleccione un sector para este usuario.",
        352: "Seleccione un cargo para este usuario.",
        353: "¿Está seguro de que desea guardar este usuario?",
        354: "¿Está seguro de que desea eliminar este usuario? Esta acción es irreversible y no podrá recuperarlo después.",
        355: "Dirección de correo electrónico completa",
        356: "Correo electrónico (Obligatorio)",
        357: "Primer nombre",
        358: "Seleccione el sector",
        359: "Seleccione el cargo",
        360: "Restringir acceso",
        361: "Restringir datos",
        362: "Seleccione la foto de perfil",
        363: "Seleccionar Imagen",
        364: "Eliminar Imagen",
        365: "Foto",
        366: "Nombre",
        367: "Gestión de usuarios",
        368: "Esta funcionalidad activada restringe el acceso a las órdenes del usuario en lo que respecta a la escuela, área, programa o cualquier subnivel de la orden de recopilación. Por lo tanto, solo estarán disponibles los datos que se hayan seleccionado para él. Por defecto, esta restricción está desactivada, permitiendo el acceso a todos los informes de la orden de recopilación.",
        369: "Esta funcionalidad activada permite que el usuario solo pueda visualizar los datos del informe del bloque en el que fue registrado. La demás información no se le entregará. Se puede combinar para restringir los datos de acceso a las órdenes de recopilación, mostrando solo la información a la que está vinculado y los datos en la orden que podrá visualizar.",
        370: "Existen evaluaciones relacionadas con esta etiqueta, ¿desea continuar con la solicitud de eliminación?",
        371: "No hay etiquetas creadas",
        372: "¿Está seguro de que desea cambiar el idioma?",
        373: "Existen estándares no asociados al idioma solicitado. Al confirmar la acción, los elementos seleccionados no serán identificados.",
        374: "Descripción de la evaluación",
        375: "Descripción de la Evaluación (Obligatorio)",
        376: "Observaciones",
        377: "Esta funcionalidad marcada habilita la posibilidad de recopilar un comentario, ya sea una queja, elogio o sugerencia.",
        378: "Esta funcionalidad está disponible para cada pregunta, independientemente de su tipo.",
        379: "Seleccione la escuela",
        380: "Seleccione el Área",
        381: "Seleccione el Programa",
        382: "Seleccione el Cliente",
        383: "Descripción del curso",
        384: "Descripción del curso (Obligatorio)",
        385: "Estilo de la Diapositiva",
        386: "Pie de página de la Diapositiva",
        387: "Color principal del diseño",
        388: "Inicio de la Recopilación",
        389: "Final de la Recopilación",
        390: "Añadir usuario responsable",
        391: "Lista de usuarios responsables",
        392: "Ningún usuario añadido",
        393: "Códigos QR de la evaluación y de la vista previa",
        394: "Acceso del estudiante",
        395: "Vista previa",
        396: "Añadir usuario de informe",
        397: "Lista de usuarios con acceso específico al informe de esta evaluación",
        398: "Seleccionar Logo",
        399: "Línea de Encabezado para portugués",
        400: "Descripción del encabezado",
        401: "Línea de Encabezado para inglés",
        402: "Línea de Encabezado para español",
        403: "Añadir logo",
        404: "Explicación",
        405: "Explicación para portugués",
        406: "Explicación para inglés",
        407: "Explicación para español",
        408: "Leyenda",
        409: "Leyenda para portugués",
        410: "Leyenda para inglés",
        411: "Leyenda para español",
        412: "Seleccione una designación",
        413: "Usuario",
        414: "Etiqueta",
        415: "Etiqueta en portugués",
        416: "Etiqueta en inglés",
        417: "Etiqueta en español",
        418: "Texto",
        419: "Texto en portugués",
        420: "Texto en inglés",
        421: "Texto en español",
        422: "Idiomas",
        423: "Prefijo (Deseable)",
        424: "Preguntas del estándar",
        425: "No es posible eliminar este elemento, es necesario tener al menos un elemento en la lista",
        426: "Encabezado de la sesión",
        427: "Descripción de la sesión (Obligatorio)",
        428: "Seleccione el área académica",
        429: "Añadir línea de profesor",
        430: "Etiqueta y texto",
        431: "Seleccione un estándar",
        432: "Añadir Preguntas",
        433: "Añadir otra pregunta",
        434: "Eliminar todas las preguntas",
        435: "Nuevo Bloque",
        436: "La fecha de apertura es posterior a la fecha de finalización.",
        437: "No se ha proporcionado una descripción para esta evaluación.",
        438: "Verifique la escuela, ya que no ha sido seleccionada.",
        439: "Verifique el área, ya que no ha sido seleccionada.",
        440: "Verifique el programa, ya que no ha sido seleccionado.",
        441: "Verifique el cliente, ya que no ha sido seleccionado.",
        442: "El curso no se ha completado correctamente.",
        443: "No se ha seleccionado un tipo de plantilla para la diapositiva.",
        444: "No se ha seleccionado un tipo de pie de página para la diapositiva.",
        445: "No se ha seleccionado un color para la diapositiva y el diseño de la evaluación.",
        446: "Incluya al menos una explicación del idioma seleccionado, ya que se ha habilitado para poner una explicación.",
        447: "Incluya al menos una leyenda del idioma seleccionado, ya que se ha habilitado para poner una explicación.",
        448: "Incluya al menos una sesión para continuar.",
        449: "No se ha proporcionado una descripción para la sesión en la posición",
        450: "No se ha seleccionado un área académica para la sesión en la posición",
        451: "No se ha seleccionado un Usuario para la sesión de Línea de Profesor para la sesión en la posición",
        452: "y en la línea",
        453: "No se ha seleccionado una Designación para la sesión de Línea de Profesor para la sesión en la posición",
        454: "Incluya al menos una Etiqueta o Texto para el idioma seleccionado para la sesión en la posición",
        455: "La pregunta",
        456: "del bloque",
        457: "y pregunta en la posición",
        458: "no admite portugués.",
        459: "no admite inglés.",
        460: "no admite español.",
        461: "¡Evaluación cerrada con éxito!",
        462: "¿Está seguro de que desea guardar esta evaluación?",
        463: "Hay elementos en conflicto o no completados, verifique:",
        464: "¿Está seguro de que desea eliminar esta evaluación? Esta acción es irreversible y no podrá recuperarla después.",
        465: "¿Está seguro de que desea guardar y notificar a los responsables de los cambios para esta evaluación?",
        466: "¿Está seguro de que desea archivar esta evaluación?",
        467: "¿Está seguro de que desea que esta evaluación vuelva a la etapa de preparación?",
        468: "¡Operación realizada con éxito!",
        469: "¿Está seguro de que desea iniciar esta evaluación y ponerla en modo listo para la recopilación?",
        470: "¿Está seguro de que desea desarchivar esta orden de recopilación?",
        471: "¿Está seguro de que desea regenerar los datos relacionados con la diapositiva, el código QR y la vista previa del código QR? Esta acción es irreversible y no podrá recuperarlos después.",
        472: "¿Está seguro de que desea cerrar esta evaluación? Los nuevos participantes no podrán enviar nuevas respuestas.",
        473: "Está gestionando la evaluación: ",
        474: "De código: ",
        475: "Archivar",
        476: "Desarchivar",
        477: "Regenerar archivos",
        478: "Listo",
        479: "Cerrar",
        480: "Guardar y Notificar",
        481: "Descargar Diapositiva",
        482: "Cerrado últimos 10d",
        483: "Seleccione nuevamente la fecha inicial y final para continuar con la búsqueda",
        484: "Simple",
        485: "Avanzada",
        486: "Buscar por estado",
        487: "Fecha inicial de búsqueda",
        488: "Fecha final de búsqueda",
        489: "Visualizar",
        490: "Copiar",
        491: "PDF",
        492: "Código de la Evaluación",
        493: "Autor",
        494: "Gestión general de evaluaciones",
        495: "Gestión de la evaluación",
        496: "General",
        497: "Encabezado",
        498: "Cuestionario",
        499: "Diapositiva",
        500: "Código de la Orden",
        501: "Copiar enlace",
        502: "¡Dirección copiada con éxito!",
        503: "Fuente Normal",
        504: "Fuente Pequeña",
        505: "Fuente Grande",
        506: "¿Le gustaría comentar esta respuesta, poner algún elogio, sugerencia o queja para la misma?",
        507: "Resultados",
        508: "respuestas recopiladas",
        509: "Nombre de la Pregunta",
        510: "Promedio",
        511: "D.P.",
        512: "Elogios, Sugerencias, observaciones, o quejas realizadas por respuesta:",
        513: "Elementos escritos para",
        514: "Ocurrencias",
        515: "Detractores",
        516: "Pasivos",
        517: "Promotores",
        518: "Las respuestas de texto libre reflejan fielmente lo que los participantes escribieron",
        519: "Esta evaluación está fuera del período de llenado",
        520: "En caso de duda, contacte a la coordinación del Programa",
        521: "Seleccione al menos un estado para realizar la búsqueda",
        522: "Seleccione el Área Académica",
        523: "Fecha inicial (Cierre)",
        524: "Fecha final (Cierre)",
        525: "No se han seleccionado datos para continuar con la consulta. Seleccione uno o más registros para continuar con la solicitud.",
        526: "En recopilación",
        527: "Informe",
        528: "Cant. Respuestas",
        529: "Consultar Agregado",
        530: "Evaluaciones en recopilación o cerradas",
        531: "Ocurrió un error. Si el problema persiste, contacte a soporte.",
        532: "Filtrar por etiqueta",
        533: "Registro vinculado a",
        534: "con éxito!",
        535: "Este registro ya estaba vinculado a",
        536: "Por razones de rendimiento, no es posible continuar con la solicitud",
        537: "Seleccione un conjunto de hasta 10 evaluaciones para continuar con la solicitud.",
        538: "¡Solicitud realizada con éxito!",
        539: "Hoja de cálculo",
        540: "Marcar",
        541: "Marcado como",
        542: "Educador",
        543: "Simple Agregado",
        544: "Documento Agregado",
        545: "El registro ya está vinculado a",
        546: "Eliminar elementos de la etiqueta",
        547: "Parámetros",
        548: "No hay datos para mostrar",
        549: "Seleccione al menos una pregunta antes de realizar la búsqueda",
        550: "Consultar",
        551: "Nueva Consulta",
        552: "¡Archivo generado con éxito!",
        553: "¡Archivo generado con éxito!",
        554: "Consultar Datos",
        555: "Adherencia debajo de",
        556: "Debajo de",
        557: "Adherencia por encima de",
        558: "Por encima de",
        559: "Adherencia a la pregunta",
        560: "Descargar",
        561: "Cargos",
        562: "¿Está seguro de que desea continuar a otra funcionalidad?",
        563: "Bloque",
        564: "Clase",
        565: "Enviar",
        566: "No Respondido",
        567: "no fue respondido",    
        568: "Hay preguntas obligatorias sin contestar, por favor revise",
        569: "¡Gracias por tu evaluación!",
        //570: "Todas las opiniones y sugerencias son cuidadosamente analizadas por nuestro equipo para que podamos seguir mejorando cada vez más.",
        570: "",        
        571: "Comportamiento",
        572: "Identificación",
        573: "Contexto",
        574: "Información adicional",
        575: "Etiquetas",        
        576: "El enlace al que accedió es inválido",
        577: "Por favor, escanee nuevamente el código QR de la evaluación o haga clic en el botón Volver para introducir el código correcto",        
        578: "Preferencia de cuenta",        
        579: "Administrar etiquetas",
        580: "Para requisitos de rendimiento, seleccione un período inferior a 180 días para continuar con la consulta.",
        581: "Informes antiguos",
        582: "Esta página muestra informes del sistema heredado. Al abrir un informe, se le redirigirá a este sistema para descargar el documento, lo que genera resultados más lentamente.",
        583: "Solicitud completada correctamente. El sistema anterior está generando el PDF, lo cual puede tardar unos minutos. Una vez finalizado el proceso, el archivo comenzará a descargarse automáticamente.",
        584: "Evaluaciones listas para recopilar y en recopilación - Panel de acciones rápidas:",
        585: "Para acceder a los informes, haga clic en el menú o en el botón de arriba.",
        586: "Aplicar",
        587: "Primero, inicie sesión en la encuesta anterior y asegúrese de estar autenticado en la herramienta y luego haga clic en el botón Cerrar X para continuar.",        
        588: "Período del informe",
        589: "Para cambiar el período, haga clic en la lupa, navegue por las opciones hasta que aparezcan las fechas de cierre y seleccione las fechas de inicio y finalización.",        
        590: "Hoja de cálculo específica",
        591: "Obtener ayuda",
        592: "¡Bienvenido a la ayuda de la encuesta ISE!",
        593: "Describa su solicitud y envíenosla para su revisión",      
        594: "Selección de categoría",
        595: "Describa la solicitud",
        596: "Sugerencia",
        597: "Ayuda",
        598: "¡Gracias por enviarnos su solicitud!",
        599: "Su mensaje es muy importante y nuestro equipo de expertos de soporte se pondrá en contacto con usted lo antes posible",     
        600: "Nombre de la evaluación",
        601: "Profesor",
        602: "Número de sesión",
        603: "Fecha de la respuesta",
        604: "Respuesta del ensayo",
        605: "Texto de la respuesta",
        606: "Valor de la respuesta",
        607: "Tabla dinámica",
        608: "Seleccionar todo",
        609: "Información académica",
        610: "Contexto de la pregunta",
        611: "Contexto de la respuesta",
        612: "Nombre Publico",
        613: "Guardar configuración",
        614: "Elegir otra configuración",
        615: "Publicado",
        616: "Biblioteca de plantillas",
        617: "Sus plantillas",
        618: "Personal",
        619: "Plantillas públicas",
        620: "Público",        
    }
};
